import { LocationLandingLayout, LocationPageContent } from './LocationLandingLayout'

const content: LocationPageContent = {
  locale: 'tr',
  slug: 'istanbul-bahcelievler-web-tasarim',
  meta: {
    title: 'İstanbul Bahçelievler Web Tasarım | Thinklyze',
    description:
      'Bahçelievler ve çevresindeki işletmeler için profesyonel web tasarım hizmetleri. Modern, hızlı ve dönüşüm odaklı web siteleri.',
    keywords: [
      'Bahçelievler web tasarım',
      'İstanbul Bahçelievler web sitesi',
      'Bahçelievler kurumsal web sitesi',
      'Bahçelievler e-ticaret sitesi',
      'Bakırköy web tasarım',
      'web tasarım Bahçelievler',
      'istanbul web tasarım ajansı',
    ],
    canonical: 'https://thinklyze.com/istanbul-bahcelievler-web-tasarim',
  },
  hero: {
    badge: 'Bahçelievler Web Tasarım',
    title: 'Bahçelievler\'deki İşletmeniz İçin Profesyonel Web Tasarım',
    subtitle:
      'Yerel müşterilerinizi çeken, Google\'da üst sıralarda yer alan ve satışa dönüştüren web siteleri tasarlıyoruz. Bahçelievler ve İstanbul Avrupa Yakası\'nın güvenilir web tasarım ortağı.',
    stats: [
      { value: '100+', label: 'Teslim Edilen Web Sitesi' },
      { value: '<2sn', label: 'Sayfa Yüklenme Hızı' },
      { value: '100%', label: 'Mobil Uyumlu' },
    ],
    highlights: [
      {
        title: 'Yerel SEO\'ya Hazır Yapı',
        description:
          'Bahçelievler ve çevresindeki aramalarda üst sıralara çıkmanız için teknik altyapıyı sıfırdan doğru kuruyoruz.',
      },
      {
        title: 'Hızlı Teslimat',
        description:
          '5–10 iş gününde yayına hazır kurumsal web siteleri. Uzun bekleme süreleri yok, proje takibi şeffaf.',
      },
      {
        title: 'Sonrası da Dahil',
        description:
          'Teslim sonrası teknik destek, güncelleme ve bakım hizmetleriyle siteniz her zaman güncel ve güvenli kalır.',
      },
    ],
  },
  problemSolution: {
    title: 'Bahçelievler İşletmelerinin Web\'deki Sorunları',
    subtitle:
      'Yerel işletmeler genellikle aynı dijital engellerle karşılaşıyor. Sizin için bunları çözüyoruz.',
    items: [
      {
        title: 'Eski ve yavaş web sitesi müşteri kaçırıyor',
        description:
          'Yüklenmesi 5 saniyeden uzun süren siteler ziyaretçilerin %53\'ünü kaybediyor. Çevik, optimize edilmiş yapımızla sitenizi ışık hızına çıkarıyoruz.',
      },
      {
        title: 'Mobil görünüm bozuk ya da kullanılamaz',
        description:
          'Türkiye\'deki internet kullanımının %70\'i mobil. Responsive ve dokunmatik uyumlu tasarımla her ekranda mükemmel görünüm sağlıyoruz.',
      },
      {
        title: 'Web sitesi yerel aramalarda çıkmıyor',
        description:
          '"Bahçelievler web tasarım" gibi sorgularda görünmemek ciddi müşteri kaybıdır. Yerel SEO uyumlu HTML yapısı ve schema markup ile bunu çözüyoruz.',
      },
      {
        title: 'Ziyaretçi var, müşteri yok',
        description:
          'Trafik getiren ama satışa dönüştüremeyen siteler bütçe israfıdır. Kullanıcı davranışına göre tasarladığımız CTA\'lar ve açılış sayfaları dönüşüm oranını artırır.',
      },
    ],
  },
  services: {
    title: 'Web Tasarım Hizmetlerimiz',
    subtitle: 'Bahçelievler ve Avrupa Yakası işletmelerine özel web çözümleri.',
    items: [
      {
        title: 'Kurumsal Web Sitesi Tasarımı',
        description:
          'Markanızı profesyonelce yansıtan, güven veren kurumsal siteler. Özel tasarım, hızlı yükleme, SEO altyapısı.',
      },
      {
        title: 'E-Ticaret Web Sitesi',
        description:
          'Shopify, WooCommerce veya özel geliştirme ile ödeme sürecini optimize eden, sepet terk oranını düşüren mağazalar.',
      },
      {
        title: 'Landing Page & Kampanya Sayfası',
        description:
          'Tek bir hedefle tasarlanmış, reklam trafiğini satışa veya forma dönüştüren yüksek dönüşümlü sayfalar.',
      },
      {
        title: 'Web Sitesi Yenileme',
        description:
          'Eski sitenizi sıfırdan yeniden tasarlıyor; hız, görünüm ve dönüşüm oranını aynı anda iyileştiriyoruz.',
      },
      {
        title: 'UI/UX Tasarım',
        description:
          'Kullanıcı araştırması ve prototiplemeyle başlayan, kullanıcı deneyimini merkeze alan tasarım süreci.',
      },
      {
        title: 'Teknik Destek & Bakım',
        description:
          'Aylık bakım planlarıyla siteniz güncel, güvenli ve hızlı kalır. Plugin güncellemeleri, yedekleme ve izleme dahil.',
      },
    ],
  },
  locationBenefits: {
    title: 'Bahçelievler\'e Yakın, Sonuçlara Yakın',
    subtitle:
      'Bakırköy\'de ofisimizle Bahçelievler işletmelerine komşu hizmet veriyoruz.',
    items: [
      {
        title: 'Yüz Yüze Toplantı İmkânı',
        description:
          'Bakırköy ofisimizde veya Bahçelievler\'de buluşarak proje detaylarını yüz yüze netleştirebilirsiniz.',
      },
      {
        title: 'Yerel Pazar Bilgisi',
        description:
          'Bahçelievler ve çevresindeki tüketici alışkanlıklarını bilerek sitenizi doğru konumlandırıyoruz.',
      },
      {
        title: 'Hızlı Geri Dönüş',
        description:
          'Aynı saat dilimi, aynı dil — değişiklik taleplerinize en geç 24 saatte yanıt veriyoruz.',
      },
      {
        title: 'Rekabetçi Fiyat',
        description:
          'İstanbul merkezdeki ajansların maliyetini taşımadan eşit kalitede hizmet alıyorsunuz.',
      },
      {
        title: 'Uzun Vadeli Ortaklık',
        description:
          'Teslim sonrası da yanınızdayız; sitenizi büyüdükçe geliştiriyor ve güncelliyoruz.',
      },
      {
        title: 'Çok Sektörlü Referanslar',
        description:
          'Bahçelievler ve çevresinde perakende, hizmet, eğitim ve sağlık sektöründen müşterilerimiz var.',
      },
    ],
  },
  process: {
    title: 'Web Tasarım Sürecimiz',
    items: [
      { title: 'Keşif & Brief', description: 'İşletmenizi, hedef kitlenizi ve rakiplerinizi anlıyoruz; proje kapsamını netleştiriyoruz.' },
      { title: 'Tasarım & Prototip', description: 'Figma\'da wireframe ve görsel tasarım; onayınızdan önce hiçbir satır kod yok.' },
      { title: 'Geliştirme', description: 'Onaylanan tasarımı hızlı ve SEO uyumlu şekilde kodluyor, testleri tamamlıyoruz.' },
      { title: 'Yayın & Destek', description: 'Sitenizi canlıya alıyor, eğitim veriyoruz ve sonrası için yanınızda oluyoruz.' },
    ],
  },
  faqs: [
    {
      question: 'Bahçelievler\'de bir web tasarım projesi ne kadar sürer?',
      answer:
        'Kurumsal web siteleri genellikle 5–10 iş günü, e-ticaret projeleri 2–4 haftada tamamlanır. Projenin karmaşıklığına göre keşif görüşmesinde netleştiriyoruz.',
    },
    {
      question: 'Web sitemi teslim aldıktan sonra kendin güncelleyebilir miyim?',
      answer:
        'Evet. WordPress veya özel CMS çözümlerimizde içeriklerinizi kolayca güncelleyebilmeniz için kısa bir eğitim veriyoruz.',
    },
    {
      question: 'Web sitemi Google\'da üst sıralara çıkaracak mısınız?',
      answer:
        'Web tasarımı sırasında teknik SEO altyapısını (hız, yapılandırılmış veri, içerik hiyerarşisi) eksiksiz kuruyoruz. Devam eden SEO kampanyası için ayrı bir paket öneriyoruz.',
    },
    {
      question: 'E-ticaret sitesi için hangi platformları kullanıyorsunuz?',
      answer:
        'Shopify, WooCommerce ve özel geliştirme seçenekleri sunuyoruz. İş modelinize ve ölçek hedefinize göre en uygun platformu birlikte belirliyoruz.',
    },
  ],
  cta: {
    badge: 'Bahçelievler\'de Web Tasarım',
    title: 'İşletmeniz İçin Dijital Yüzünüzü Yenileyin',
    description:
      'Ücretsiz web sitesi değerlendirmesi için bugün iletişime geçin. Mevcut sitenizin eksiklerini, rakip konumlandırmanızı ve iyileştirme fırsatlarını birlikte ele alıyoruz.',
  },
  areaServed: ['Bahçelievler', 'Bakırköy', 'Bağcılar', 'Güngören', 'Küçükçekmece', 'İstanbul Avrupa Yakası'],
  coordinates: { latitude: 41.0016, longitude: 28.8776 },
  address: {
    streetAddress: 'Zeytinlik Mah. Fişekhane Cad. Carousel No: 5 İç Kapı No: 17',
    addressLocality: 'Bakırköy',
    addressRegion: 'İstanbul',
    postalCode: '34140',
    addressCountry: 'TR',
  },
  relatedServices: {
    title: 'İlgili Hizmetlerimiz',
    items: [
      { name: 'SEO & GEO Optimizasyon', href: '/services/seo-geo', description: 'Web sitenizi Google\'da üst sıralara taşıyın.' },
      { name: 'Google Ads Yönetimi', href: '/services/google-ads', description: 'Sitenize anında kaliteli trafik çekin.' },
      { name: 'Shopify Danışmanlığı', href: '/shopify', description: 'Shopify mağazanızı büyütün.' },
      { name: 'Uygulama Geliştirme', href: '/services/app-development', description: 'Mobil uygulama ile müşterinize her an ulaşın.' },
    ],
  },
}

const IstanbulBahcelievlerWebTasarim = () => {
  return <LocationLandingLayout content={content} />
}

export default IstanbulBahcelievlerWebTasarim
